import classNames from "classnames/bind";
import styles from "./Home.module.scss";
import CarouselSlider from "../../../components/carouselSlider/CarouselSlider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import Tabs from "../../../components/Tabs/Tabs";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { useEffect, useState } from "react";
import { IPost } from "../../../types/backend";
import { fetchPost } from "../../../redux/slice/postSlice";
import DateFormat from "../../../utils/formatTime/DateFormat";
import { FORMAT_DATE } from "../../../utils/constants/timeFormat";
import { useNavigate } from "react-router-dom";
import ImgBanner from "../../../assets/images/banner2.jpg";
import { Card, Empty, Pagination } from "antd";

const css = classNames.bind(styles);

function Home() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { result: posts, meta: metaPost } = useAppSelector(
    (state) => state.post
  );
  const { result: categories, isFetching: loadingCategory } = useAppSelector(
    (state) => state.category
  );
  const [categoryName, setCategoryName] = useState({ name: "", _id: "" });
  const [pageSize, setPageSize] = useState(6);
  const [page, setPage] = useState(1);

  let query = `current=${page}&pageSize=${pageSize}&sort=-createdAt&categoryId=${categoryName?._id}`;
  useEffect(() => {
    dispatch(
      fetchPost({
        query: query,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryName._id, query]);

  const handleDetailPost = (event: any, id: any) => {
    event.preventDefault(); // Ngăn chuyển hướng đến liên kết mặc định
    const anchor = event.target;
    anchor.removeAttribute("href"); // Loại bỏ thuộc tính href của thẻ a
    navigate(`/post-detail/${id}`);
  };
  const onChange = (currentPage: any, currentPageSize: any) => {
    if (currentPage !== page) {
      setPage(currentPage);
    }

    if (currentPageSize !== pageSize) {
      setPageSize(currentPageSize);
      setPage(1);
    }
  };
  // const handleIsLoading = (): any => {
  //   return <>{posts.length === 0 ? <SkeletonLoading /> : <Loading />}</>;
  // };
  return (
    // <Spin spinning={loadingPost}>
    <div className={css("wrapper")}>
      <>
        <div className={css("banner-visible")}>
          <img className={css("banner-visible")} src={ImgBanner} alt="logo" />
        </div>
        <div className={css("carousel-slider")}>
          <div className={css("title-carousel-slider")}>
            <h3>Danh mục bài viết</h3> <button>Xem thêm</button>
          </div>
          {/* <Loading /> */}
          <CarouselSlider categories={categories} />
          {loadingCategory && <Card loading={true}></Card>}
        </div>
        <Tabs
          categories={categories}
          setCategoryName={setCategoryName}
          setPage={setPage}
        />
        <div className={css("content-section")}>
          <div className={css("content-left")}>
            {posts?.length === 0 && <Empty style={{marginTop: 50}} description="Không có dữ liệu"/>}
           
            <div className={css("content-section-left")}>
              {posts &&
                posts.length > 0 &&
                posts.map((item: IPost, index) => {
                  return (
                    <div className={css("item")} key={index}>
                      <img
                        src={item.image}
                        alt="no avatar"
                        onClick={(e) => handleDetailPost(e, item._id)}
                      />
                      <h3 className={css("content-title")}>
                        <a
                          href="##"
                          onClick={(e) => handleDetailPost(e, item._id)}>
                          {item.title}
                        </a>
                      </h3>
                      <div className={css("recent-content")}>
                        <span className={css("recent-author")}>
                          <FontAwesomeIcon icon={faPenToSquare} size="1x" />{" "}
                          <p>{item.createdBy?.name}</p>
                        </span>
                        <span className={css("recent-day")}>
                          <FontAwesomeIcon icon={faClock} size="1x" />{" "}
                          <DateFormat
                            time={item.createdAt}
                            format={FORMAT_DATE}
                          />
                        </span>
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className={css("content-section-pagination")}>
              <Pagination
                current={page}
                pageSize={pageSize}
                total={metaPost.total}
                showSizeChanger={false}
                onChange={onChange}
              />
            </div>
          </div>
          <div className={css("content-section-right")}>
            <h3 className={css("title-aside")}>Bài viết mới nhất</h3>
            <div className={css("content-aside")}>
              {posts &&
                posts.length > 0 ?
                posts.map((item, index) => {
                  return (
                    <div className={css("post-aside")} key={index}>
                      <img src={item.image} alt="no avatar" />
                      <div>
                        <h3
                          className={css("post-title")}
                          onClick={(e) => handleDetailPost(e, item._id)}>
                          <a href="##">{item.title}</a>
                        </h3>
                        <div className={css("recent-content-post")}>
                          <span className={css("recent-info")}>
                            <FontAwesomeIcon icon={faPenToSquare} size="1x" />{" "}
                            <span>{item.createdBy?.name}</span>
                          </span>
                          <span className={css("recent-info")}>
                            <FontAwesomeIcon icon={faClock} size="1x" />{" "}
                            <DateFormat
                              time={item.createdAt}
                              format={FORMAT_DATE}
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                }) : <Empty style={{marginTop: 50}} description="Không có dữ liệu" />}
            </div>
          </div>
        </div>
      </>
      {/* {loadingPost && <Loading />} */}
    </div>

    // </Spin>
  );
}

export default Home;
